import { useEffect } from 'react';
import { registerPushNotifications } from '../push/registerPush';
import { useToast } from '../context/ToastContext';

/** Head/teacher only — request push permission after login (Android). */
export function PushNotificationSetup({ role, useMalayalam, hasToken }) {
  const { toast } = useToast();

  useEffect(() => {
    if (!hasToken) return;
    if (role !== 'head' && role !== 'teacher') return;

    registerPushNotifications({ useMalayalam }).catch((err) => {
      console.warn('Push setup failed:', err);
    });
  }, [role, useMalayalam, hasToken]);

  useEffect(() => {
    const onPush = (event) => {
      const { title, body } = event.detail || {};
      const text = [title, body].filter(Boolean).join(' — ');
      if (text) toast(text, 'info', 8000);
    };
    window.addEventListener('nmhelper:push-received', onPush);
    return () => window.removeEventListener('nmhelper:push-received', onPush);
  }, [toast]);

  return null;
}
